import router from './router'

const whiteList = ['/wd','/sy','/ygpp','/xs'] // 不重定向白名单
window.addEventListener("popstate", function (e) {
    /* router.beforeEach((to, from, next) => {
        if (whiteList.indexOf(from.path) > -1) {
            //next(false)    
            var state = {
                title: "title",
                url: "#" + from.path
            };
            window.history.pushState(state, "title", "#" + from.path);   
        }else{
            next() 
        } 
    }) */
    
}, false);



// WEBPACK FOOTER //
// ./src/permission.js